/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PutUserRequestsIdPathParams,
  PutUserRequestsId200,
  PutUserRequestsId400,
  PutUserRequestsIdMutationRequest,
  PutUserRequestsIdMutationResponse,
} from '../entities/PutUserRequestsId'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1UpdateUserRequestInputSchema } from './v1/updateUserRequestInputSchema'
import { z } from 'zod'

export const putUserRequestsIdPathParamsSchema = z.object({
  id: z.string().describe('ID заявки'),
}) as unknown as ToZod<PutUserRequestsIdPathParams>

/**
 * @description OK
 */
export const putUserRequestsId200Schema = z.any() as unknown as ToZod<PutUserRequestsId200>

/**
 * @description Bad Request
 */
export const putUserRequestsId400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PutUserRequestsId400>

/**
 * @description Данные заявки
 */
export const putUserRequestsIdMutationRequestSchema = z.lazy(() => v1UpdateUserRequestInputSchema) as unknown as ToZod<PutUserRequestsIdMutationRequest>

export const putUserRequestsIdMutationResponseSchema = z.lazy(() => putUserRequestsId200Schema) as unknown as ToZod<PutUserRequestsIdMutationResponse>